// package: report
// file: report/service.proto

import * as common_service_options from "../common/service_options";
import * as common_method_options from "../common/method_options";
import * as report_model from "../report/model";

import { interfaceAPI } from "../sdk/api";

export const ReportEventsRequest = {
    encode(object) {
        const message = {};
        if (object.common != null) {
            if (typeof object.common !== "object") {
                throw TypeError("common: object expected");
            }
            const keys = Object.keys(object.common);
            if (keys.length > 0) {
                message.common = {};
                for (let i = 0; i < keys.length; ++i) {
                    if (object.common[keys[i]] !== "") {
                        message.common[keys[i]] = String(object.common[keys[i]]);
                    }
                }
            }
        }
        if (object.events != null) {
            if (!Array.isArray(object.events)) {
                throw TypeError("events: array expected");
            }
            if (object.events.length > 0) {
                message.events = [];
                for (let i = 0; i < object.events.length; ++i) {
                    message.events[i] = report_model.Item.encode(object.events[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            common: {},
            events: [],
        };

        if (message.common != null) {
            const keys = Object.keys(message.common);
            object.common = {};
            for (let i = 0; i < keys.length; ++i) {
                    object.common[keys[i]] = message.common[keys[i]];
            }
        }
        if (message.events != null) {
            object.events = [];
            for (let i = 0; i < message.events.length; ++i) {
                object.events[i] = report_model.Item.decode(message.events[i]);
            }
        }
        return object;
    },
};

export const ReportEventsReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ReportLogsRequest = {
    encode(object) {
        const message = {};
        if (object.logs != null) {
            if (!Array.isArray(object.logs)) {
                throw TypeError("logs: array expected");
            }
            if (object.logs.length > 0) {
                message.logs = [];
                for (let i = 0; i < object.logs.length; ++i) {
                    message.logs[i] = report_model.Item.encode(object.logs[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            logs: [],
        };

        if (message.logs != null) {
            object.logs = [];
            for (let i = 0; i < message.logs.length; ++i) {
                object.logs[i] = report_model.Item.decode(message.logs[i]);
            }
        }
        return object;
    },
};

export const ReportLogsReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ReportPlayerEventsRequest = {
    encode(object) {
        const message = {};
        if (object.events != null) {
            if (!Array.isArray(object.events)) {
                throw TypeError("events: array expected");
            }
            if (object.events.length > 0) {
                message.events = [];
                for (let i = 0; i < object.events.length; ++i) {
                    message.events[i] = String(object.events[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            events: [],
        };

        if (message.events != null) {
            object.events = [];
            for (let i = 0; i < message.events.length; ++i) {
                    object.events[i] = message.events[i];
            }
        }
        return object;
    },
};

export const ReportPlayerEventsReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export function ReportEvents(request, options) {
    return interfaceAPI("/report.Default/ReportEvents", ReportEventsRequest.encode(request), ReportEventsReply, Object.assign({ isAuthFree: 1, }, options));
}

export function ReportLogs(request, options) {
    return interfaceAPI("/report.Default/ReportLogs", ReportLogsRequest.encode(request), ReportLogsReply, Object.assign({ isAuthFree: 1, }, options));
}

export function ReportPlayerEvents(request, options) {
    return interfaceAPI("/report.Default/ReportPlayerEvents", ReportPlayerEventsRequest.encode(request), ReportPlayerEventsReply, Object.assign({ isAuthFree: 1, }, options));
}


